import { createAct } from 'coact/utils/action'

export default createAct({
  namespace: ['hehong', 'ArrivalProcess'],
  types: [
    'findUnarrivedItems',
    'findSuppliersInProgress',
    'exportInProgressList',
    'createPurchaseOrder',
    'clickSupplier',
  ],
})
